<div class="progress-wrapper" id="main-content" *ngIf="(cart$ | async).shopping_cart_id">
    <ridango-page-content-wrapper>
        <ridango-progress-v2 [steps]="steps$ | async" [activeStep]="activeStep$ | async"> </ridango-progress-v2>
    </ridango-page-content-wrapper>
</div>

<div class="block--content block">
    <div class="block--wrap block">
        <div class="ticket">
            <rwidget-alert></rwidget-alert>

            <rwidget-adyen-integration
                [redirectedPaymentResult]="redirectedPayment"
                (paymentResult)="managePayment($event)"></rwidget-adyen-integration>

            <ridango-block-full-width *ngIf="paymentResult">
                <p class="align-center">{{ 'ADYEN_PAYMENT_WAITING_FOR_RESULT' | translate }}</p>
                <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate">
                </ridango-ui-basic-loading-spinner>
            </ridango-block-full-width>
        </div>
    </div>
</div>

<rwidget-navigate-away-modal
    [showNavigationModal]="showNavigationModal"
    (onConfirmNavigation)="onConfirmNavigationModal()"
    (onCancelNavigation)="onCloseNavigationModal()"></rwidget-navigate-away-modal>
